import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=a5ffbb3a&scoped=true&"
import script from "./pager.vue?vue&type=script&lang=js&"
export * from "./pager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ffbb3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5ffbb3a')) {
      api.createRecord('a5ffbb3a', component.options)
    } else {
      api.reload('a5ffbb3a', component.options)
    }
    module.hot.accept("./pager.vue?vue&type=template&id=a5ffbb3a&scoped=true&", function () {
      api.rerender('a5ffbb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pager.vue"
export default component.exports